import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-91079054"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "breadcrumb-container"
};
const _hoisted_2 = {
  key: 0,
  class: "redirect"
};
const _hoisted_3 = {
  key: 1,
  class: "no-redirect"
};
const _hoisted_4 = {
  key: 2,
  class: "redirect"
};
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
export default {
  __name: 'breadcrumb',
  setup(__props) {
    const route = useRoute();
    const parentName = ref("");
    const breadcrumbList = ref([]);
    const initBreadcrumbList = () => {
      breadcrumbList.value = route.matched;
      parentName.value = route.meta.parentName;
    };
    watch(route, () => {
      initBreadcrumbList();
    }, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbList.value, (item, index) => {
          return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
            key: index
          }, {
            default: _withCtx(() => [parentName.value && index > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(parentName.value) + "  / ", 1)) : _createCommentVNode("", true), index == breadcrumbList.value.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.name), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.name), 1))]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]);
    };
  }
};